import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "D:/personal/githubrepo/rx-form-state/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Props } from 'docz';
import RelyRule from '../../src/RelyRule';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "relyrule"
    }}>{`RelyRule`}</h1>
    <p>{`添加值关联计算规则的组件。`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import { RelyRule } from '@sinoui/rx-form-state';
`}</code></pre>
    <h2 {...{
      "id": "基本用法"
    }}>{`基本用法`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`<RelyRule
  relyFields={['B', 'C']}
  relyFn={(draft) => {
    draft.A = draft.B + draft.C + 3;
  }}
/>
`}</code></pre>
    <p>{`注意，此组件只能在表单上下文中使用。如：`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`<Form state={formState}>
  <RelyRule
    relyFields={['B', 'C']}
    relyFn={(draft) => {
      draft.A = draft.B + draft.C + 3;
    }}
  />
</Form>
`}</code></pre>
    <p>{`或者：`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`<FormStateContext.Provider value={formState}>
  <RelyRule
    relyFields={['B', 'C']}
    relyFn={(draft) => {
      draft.A = draft.B + draft.C + 3;
    }}
  />
</FormStateContext.Provider>
`}</code></pre>
    <h2 {...{
      "id": "本质"
    }}>{`本质`}</h2>
    <p>{`此组件只是简单封装了一下 `}<inlineCode parentName="p">{`formState.addRelyRule`}</inlineCode>{` 方法，相当于：`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`function FormDemo() {
  const formState = useFormState();

  useEffect(() => {
    return formState.addRelyRule(['B', 'C'], (draft) => {
      draft.A = draft.B + draft.C;
    });
  }, [formState]);
}
`}</code></pre>
    <h2 {...{
      "id": "属性"
    }}>{`属性`}</h2>
    <Props of={RelyRule} mdxType="Props" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      